import BaseModel from '../base/BaseModel.model';
import CertificactionDocument from './certificactionDocument.Model';
export default class CertificationUser extends BaseModel {

    public userId?: number;
    public year?:  Date | any;
    public certificationDescription?:  string;
    public spelledBy?: string;
    public certificactionDocuments: Array<CertificactionDocument> = [];
    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.certificationDescription = "";
        this.spelledBy = "";   
        this.certificactionDocuments = [];
      
    }
}